//import axios from "axios";
import Tab from './tabs/tab.vue';

export default {
  name: 'pdpTabs',
  components: {
    Tab,
  },
  props: ['productId', 'abVersion', 'delDiaProduct', 'delDiaApparel'],
  data() {
    return {
      tabs: [],
      selectedTabIndex: 0,
    };
  },
  methods: {
    selectTab(i) {
      this.selectedTabIndex = i;
    },
  },
  created() {},
  beforeMount() {
    // get tab content through API call
    let targetdomain = window.location.hostname.includes(
      'development.cotopaxi.com'
    )
      ? 'https://development-access-api.cotopaxi.com'
      : 'https://production-access-api.cotopaxi.com';

    axios
      .get(
        targetdomain +
          `/product/getProductForStorefrontByProductId/${this.productId}`
      )
      .then((response) => {
        const tabContentFromApi = response.data.sections.infoTabs;

        // set tab content
        if (tabContentFromApi) {
          // hardcode version to be 'a' per ecomm team
          this.tabs = tabContentFromApi['a'];

          // temporary fix to standardize factory information copy while new copy system is being built
          const factoryTabIndex = this.tabs.findIndex((tab) =>
            tab.title.toLowerCase().includes('factory')
          );
          if (factoryTabIndex > -1) this.tabs.splice(factoryTabIndex, 1);
          const tab = {};
          if (this.delDiaProduct && !this.delDiaApparel) {
            tab.title = 'Factory Information';
            tab.content = `Our Del Día Collection is made at several factories operated by Dong In Entech in the Bataan Province of the Philippines. As our principal pack maker, Dong In Entech is committed to fair labor and environmentally sound practices.<br><br>
              Known for producing best-in-class technical items like our Allpa Collection, this factory also partners with us in reducing fabric waste through our Del Día packs & bags, which are made from high-quality, leftover deadstock.<br><br>
              <a href="https://www.cotopaxi.com/pages/bataan-factory" target="_blank"><strong>Learn more</strong></a> about Dong In.`;
          } else if (this.delDiaProduct && this.delDiaApparel) {
            tab.title = 'Factory Information';
            tab.content = `Our Renovo Collection is produced at the Portland Garment Factory based in Portland, Oregon. This woman-owned, zero-waste design and fabrication studio is a B Corp known for prioritizing circularity, sustainability, and a democratic operating model. <a href="https://www.cotopaxi.com/pages/portland-garment-factory" target="_blank"><strong>Learn more</strong></a> about Portland Garment Factory.`;
          } else {
            tab.title = 'Factory Information';
            tab.content = `We're proud to partner with factories that agree to rigorous codes of conduct, prioritize sustainable operating practices, and are Fair Trade Certified™ or promote fair labor practices.<br><br>
              The manufacturing partners we work with commit to:<br>
              <ul>
                <li>- Adhere to the UN Global Compact and Principles of Responsible Business</li>
                <li>- Conduct annual audits and anonymous supplier surveys</li>
                <li>- Adopt the principles of Ethical Trading Initiative's Better Buying Guide</li>
              </ul><br>
              <a href="https://www.cotopaxi.com/pages/our-manufacturing-partners" target="_blank"><strong>Learn more</strong></a> about our manufacturing partners.`;
          }
          this.tabs.push(tab);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  mounted() {
    // let parent = document.querySelector('.ctpx-pdp-details').parentElement;

    // while (parent) {
    // 	const hasOverflow = getComputedStyle(parent).overflow;
    // 	if (hasOverflow !== 'visible') {
    // 		console.log(hasOverflow, parent);
    // 	}
    // 	parent = parent.parentElement;
    // }
    this.selectTab(0);
  },
};
